import {memo} from 'react';

import {ComponentBySize} from '~/shared/components/UserTransactions/shared';

import {DesktopMoneyCardDetails, MobileMoneyCardDetails} from './components';

const MoneyCardDetails = ({moneyCardsList, dateBias, reportSetting, setOrderListData, onAutoCreditSubscribeSuccess}) => {
  if (dateBias !== 0 || reportSetting?.hideMoneycardLimitsAndBalance) {
    return null;
  }

  return (
    <ComponentBySize
      MobileComponent={MobileMoneyCardDetails}
      DesktopComponent={DesktopMoneyCardDetails}
      props={{
        moneyCardsList,
        reportSetting,
        isIntelReport: reportSetting?.isIntelReport,
        setOrderListData,
        onAutoCreditSubscribeSuccess,
      }}
    />
  );
};

export default memo(MoneyCardDetails);
